import React, {useEffect, useState} from "react";
import {memo} from "react";
import * as _ from "lodash";
import Dialog from "../Dialogs/Dialog";
import {GridApi} from "ag-grid-community";
import i18next from "i18next";
import TextFieldRegEx from "../TextFieldRegEx";
import {RegexFactory} from "src/services/ColumnFactory";
import SelectField from "../SelectField";
import {CnrDto, KumaCnrByRegionParams, KumaViewDto, RegionDto} from "src/services/Client";
import DataAdapterKumaView from "src/views/KumaView/DataAdapterKumaView";
import HATEOASClient from "src/services/HATEOASClient";
import Button from "../Button";
import {Table} from "semantic-ui-react";
import {renderErrorToast} from "src/utils/FeedbackMessageUtils";

interface IOwnProps {
    data: any;
    api: GridApi;
    t: i18next.TranslationFunction<any, object, string>;
    kumaExtraLinks?: any;
    userCnrs?: any;
    client?: HATEOASClient;
    parentProps: any;

}
const regionRenderer = (region: RegionDto) => region.name;
const marketRenderer = (market: CnrDto) => market.name;
export const RegionMarketEdit = memo((props: IOwnProps) => {
    const {data, api, t} = props;
    const [open, setOpen] = useState(true);
    const [upItem, setUpItem] = useState({...props.data});
    const [regionRes, setRegionRes] = useState<any>(null);
    const [market, setMarket] = useState([]);
    const {kumaExtraLinks, client, onRowUpdate} = props.parentProps;
    const loadData = async () => {
        if (kumaExtraLinks) {
            const regions = await client.GET_kumaRegionList(kumaExtraLinks).execute();
            if (regions.elements) {
                regions.elements.unshift({
                    objectId: 0,
                    name: t("KUMA_VIEW:ALL_REGIONS"),
                    versionId: 0,
                    id: 0
                });
            }
            const params: KumaCnrByRegionParams = {
                regionIds: [1, 2, 3, 4, 5]
            };
            const markets = await client.GET_kumaCnrList(kumaExtraLinks).execute(params);
            if (markets.elements) {
                markets.elements.unshift({
                    objectId: 0,
                    name: t("KUMA_VIEW:ALL_MARKETS"),
                    versionId: 0,
                    cnr: t("KUMA_VIEW:ALL_MARKETS")
                });
            }
            setRegionRes(regions);
            setMarket(markets.elements);
            if(upItem.regions.length === regions.elements.length-1) {
                upItem.regions = [regions.elements[0]];
            }
            if(upItem.assignedCnrs.length === markets.elements.length-1) {
                upItem.assignedCnrs = [markets.elements[0]];
            }
            setUpItem({...upItem});
        }
    };

    useEffect(
        () => {
            loadData();
        },
        []
    );

    const onRegionChange = async (selectedValue?: RegionDto[]) => {
        const newItem = _.cloneDeep(upItem);
        newItem.regions = selectedValue!.map((item: any) => item.selectedValue);
        if (newItem.regions && newItem.regions.find((p: any) => p.objectId === 0)) {
            newItem.regionNeg = false;
            newItem.marketNeg = false;
            newItem.assignedCnrs = market.filter((p: any) => p.objectId !== 0);
            newItem.regions = regionRes.elements.filter((p: any) => p.objectId !== 0);
            setUpItem({...newItem});
            return;
        }
        newItem.assignedCnrs = [];
        if (selectedValue && selectedValue.length > 0) {
            const selectedRegionIds = newItem.regions.map((p: any) => p.objectId);
            market.forEach((p: CnrDto) => {
                if (p.region) {
                    if (selectedRegionIds.indexOf(p.region.id) !== -1) {
                        newItem.assignedCnrs.push(p);
                    }
                }
            });
        }
        setUpItem({...newItem});
    };
    const onMarketChange = async (selectedValue?: CnrDto[]) => {
        const newItem = _.cloneDeep(upItem);
        newItem.assignedCnrs = selectedValue!.map((item: any) => item.selectedValue);
        if (newItem.assignedCnrs && newItem.assignedCnrs.find((p: any) => p.objectId === 0)) {
            newItem.assignedCnrs = market.filter((p: any) => p.objectId !== 0);
            newItem.regions = regionRes.elements.filter((p: any) => p.objectId !== 0);
            newItem.marketNeg = false;
            newItem.regionNeg = false;
            setUpItem({...newItem});
            return;
        }
        const selectedMarketRegionIds = selectedValue!.map((values: any) => values.selectedValue.region.id);
        const regionsIds = regionRes.elements.map((p: RegionDto) => p.objectId);
        const removeIds: Array<number> = [];
        regionsIds.forEach((element: any) => {
            if (selectedMarketRegionIds.indexOf(element) === -1) {
                removeIds.push(element);
            }
        });
        newItem.regions = regionRes.elements.filter((p: RegionDto) => removeIds.indexOf(p.objectId) === -1);
        setUpItem({...newItem});
    };
    const handleUpdate = () => {
        onRowUpdate(upItem);
    };
    return (
        <Dialog
            title={`${t("KUMA_VIEW:KUMA_EDIT_MARKET_REQ")} - ${data.title}`}
            open={open}
            actions={[
                <Button
                    key={1}
                    icon={"checkmark"}
                    disabled={upItem.regions.length === 0 || upItem.assignedCnrs.length === 0}
                    onClick={handleUpdate}
                />,
                <Button
                    key={"closeButton"}
                    icon={"ban"}
                    onClick={() => setOpen(false)}
                />
            ]}
        >
            <Table basic='very'>
                <Table.Body>
                    <Table.Row>
                        <Table.HeaderCell width={3}>{t("KUMA_VIEW:REGION")}<b>*</b></Table.HeaderCell>
                        <Table.Cell>
                            {regionRes && <SelectField
                                clearable={true}
                                multi={true}
                                dataSource={regionRes.elements}
                                value={upItem.regions}
                                rendererKey={regionRenderer}
                                onChange={onRegionChange}
                            />}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell width={3}>{t("KUMA_VIEW:MARKET")}<b>*</b></Table.HeaderCell>
                        <Table.Cell >
                            {market.length > 0 && <SelectField
                                clearable={true}
                                multi={true}
                                dataSource={market}
                                value={upItem.assignedCnrs}
                                rendererKey={marketRenderer}
                                onChange={onMarketChange}
                            />}
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </Dialog>
    );
});



// WEBPACK FOOTER //
// ./src/components/kuma/RegionMarketEdit.tsx